module.exports = __webpack_public_path__ + "img/n5.8f6a84a7.png";